import React from 'react';
import { CHANGE, pt, topFromBaseline, u } from './geometry';
import { ComabooksFooter } from './ComabooksFooter';
import './ComabooksPage.css';

export interface ComabooksTextPageProps {
  question?: string;
  answer?: string;
  /** Вопрос скрыт (client_question = '-'): ответ с самого верха. */
  hideQuestion?: boolean;
  footerTitle?: string;
  footerAuthor?: string;
  pageNumber?: number;
  className?: string;
}

/**
 * Первая страница вопроса Comabooks (миниатюра). Печать — drawPair в
 * pdfGeneratorComabooks.ts: вопрос Playfair 36pt (x 171, baseline 206,
 * ширина 768), ответ Playfair 80pt, межстрочный 76.8 px, начало на 100 px
 * ниже вопроса (+24 px на строку вопроса). Переполнение обрезается.
 */
export const ComabooksTextPage: React.FC<ComabooksTextPageProps> = ({
  question = '',
  answer = '',
  hideQuestion = false,
  footerTitle = '',
  footerAuthor = '',
  pageNumber,
  className = '',
}) => {
  const qY = 195 + CHANGE;
  // ≈ строк вопроса: Playfair 36pt ≈ 13 px макета на символ.
  const qLines = Math.max(1, Math.ceil((question.length * 13) / 768));
  const aY = (hideQuestion ? 195 : qY + 100) + qLines * 24;
  return (
    <div className={`cbp ${className}`}>
      <div className="cbp__sheet">
        {!hideQuestion && (
          <div
            className="cbp__question"
            style={{ left: u(160 + CHANGE), top: topFromBaseline(qY, 36), width: u(768), fontSize: pt(36) }}
          >
            {question}
          </div>
        )}
        <div
          className="cbp__answer"
          style={{
            left: u(160 + CHANGE),
            top: topFromBaseline(aY, 80, 1.055),
            width: u(768),
            fontSize: pt(80),
            maxHeight: u(1298 - aY + 60),
            overflow: 'hidden',
          }}
        >
          {answer}
        </div>
        <ComabooksFooter title={footerTitle} author={footerAuthor} pageNumber={pageNumber} />
      </div>
    </div>
  );
};
